<template>
  <div id="contact" class="row mt-3 container mx-auto">
    <b-col cols="12" md="6" class="text-center text-md-left">
      <h2>Kontakt</h2>
      <hr/>
      <div>
        <h3 class="font-weight-bold">
          Jasle Veselá Hviezdička
        </h3>
        <div>
          <article>
            Čínska 24
          </article>
          <article>
            040 13 Košice
          </article>
        </div>
        <div class="mt-4">
          <h4 class="font-weight-bold">
            Kontaktná osoba:
          </h4>
          <article>Patrícia Orolin</article>
          <a href="tel:+421915159819" class="text-blue">0915 159 819</a> <br/>
          <a href="mailto:veselahviezdicka@gmail.com" class="text-blue">
            veselahviezdicka@gmail.com</a>
        </div>
        <div class="mt-4">
          <h4 class="font-weight-bold">
            Prevádzkovateľ:
          </h4>
          <article>Občianske združenie Veselá Hviezdička</article>
          <article>Sídlo: Školská 790,951 73 Jelenec</article>
          <article>ICO: 52973905</article>
          <article>DIC: 2121294945</article>
          <article>IBAN: SK10 5600 0000 0065 8491 3002</article>
        </div>
      </div>
    </b-col>
    <b-col cols="12" md="6">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2630.2838477030086!2d21.27225241596874!3d48.75737551576755!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x473ee0b8161d0db9%3A0xda18b65fa9ffebf5!2zTWF0ZXJza8OhIMWga29sYSDEjMOtbnNrYQ!5e0!3m2!1sfr!2ssk!4v1596033093113!5m2!1sfr!2ssk"
        width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen=""
        aria-hidden="false"
        tabindex="0"></iframe>
    </b-col>
    <b-col cols="12" class="pt-4">
      <h3 class="font-weight-bold">Súhlas dotknutej osoby so spracovaním osobných údajov</h3>
      <p>

        V zmysle zákona Slovenskej republiky č. 18/2018 Z. z. o ochrane osobných údajov a o zmene
        a doplnení niektorých zákonov, ktorý najmä v § 19-30 upravuje práva dotknutej osoby
        v oblasti spracovania osobných údajov, vyjadrujem súhlas Občianskemu združeniu
        Veselá Hviezdička so spracovaním poskytnutých osobných údajov uvedených v Dohode
        poskytovania starostlivosti o dieťa a v priložených prílohách, za účelom administrácie
        do uplynutia doby
        poskytovania starostlivosti o dieťa v jasliach Veselá Hviezdička.
        Uvedený súhlas sa týka aj použitia videozáznamov a fotografii z akcií použitých
        na propagáciu zariadenia
        starostlivosti pre deti do 3 rokov veku dieťaťa.
      </p>
    </b-col>
  </div>
</template>

<script>
export default {};
</script>
